import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Images
import itcounsulting from "../img/itcounsulting.jpg";
import cloud from "../img/cloud.jpg";
import bps from "../img/bps.jpg";
import ai from "../img/ai.jpg";
import dm from "../img/dm.jpg";
import cyber from "../img/cyber.jpg";
import skill from "../img/skill.jpg";
import csd from "../img/csd.jpg";
import ui from "../img/ui.jpg";
import whobanner from "../img/ourcorexperts.jpg";

const OurServices = () => {
  const [showScroll, setShowScroll] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
      setShowScroll(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const featuredServices = [
    {
      title: "Custom Software Development",
      description:
        "We build secure, scalable, and innovative software solutions that drive real business growth and digital transformation.",
      image: csd,
      link: "/custom-software-development",
      icon: "fa-laptop-code",
    },
    {
      title: "IT Support & Managed Services",
      description:
        "We help businesses in Hyderabad run smoothly and grow efficiently with reliable, proactive IT support and managed services.",
      image: itcounsulting,
      link: "/it-support-services",
      icon: "fa-headset",
    },
    {
      title: "Cloud & Infrastructure Services",
      description:
        "Trusted cloud service providers delivering secure, scalable, and cost-effective cloud solutions for modern business success.",
      image: cloud,
      link: "/cloud-service-providers",
      icon: "fa-cloud",
    },
    {
      title: "Business Process Outsourcing (BPO)",
      description:
        "Boost efficiency, reduce operational costs, and enhance customer satisfaction with our reliable and intelligent BPO solutions.",
      image: bps,
      link: "/bpo-services",
      icon: "fa-users-cog",
    },
    {
      title: "AI & Data Analytics Solutions",
      description:
        "Unlock real-time insights, predictive intelligence, and smarter workflows with advanced AI-powered data analytics.",
      image: ai,
      link: "/data-analytics-services",
      icon: "fa-chart-line",
    },
    {
      title: "Digital Marketing Services",
      description:
        "Transform your brand’s digital presence with AI-driven, data-backed strategies that deliver measurable growth and engagement.",
      image: dm,
      link: "/digital-marketing-services",
      icon: "fa-bullhorn",
    },
    {
      title: "UI/UX Design Services",
      description:
        "Get modern, intuitive, and conversion-focused websites & mobile app designs that delight users and elevate your brand.",
      image: ui,
      link: "/ui-ux-design-services",
      icon: "fa-palette",
    },
    {
      title: "Cybersecurity Services",
      description:
        "Protect your business with advanced cybersecurity solutions, proactive threat detection, and complete data assurance.",
      image: cyber,
      link: "/cybersecurity-services",
      icon: "fa-shield-alt",
    },
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      <Helmet>
        <title>Our Services | SecurXpert Technologies - Hyderabad</title>
        <meta
          name="description"
          content="Explore SecurXpert's services: Custom Software, IT Support, Cloud, Cybersecurity, Mobile Apps, Data Analytics, UI/UX & Digital Transformation."
        />
        <link rel="canonical" href="https://securxperts.com/our-services" />
      </Helmet>

      <Navbar />

      {/* Hero Banner */}
      <header className="relative w-full">
        <div
          className="relative w-full h-[317px] bg-center bg-cover"
          style={{ backgroundImage: `url(${whobanner})` }}
        >
          <div className="absolute inset-0 bg-black/70"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Our Services
            </h1>

            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="hover:underline">Home</Link>
              <span>/</span>
              <span>Our Services</span>
            </div>
          </div>
        </div>
      </header>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">

          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-[#210A4A]">Our Core Services</h2>
            <p className="text-lg text-gray-600 mt-3">
              From strategy to execution — we deliver future-ready solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredServices.map((service, index) => (
              <div
                key={index}
                className="service-card bg-white rounded-2xl shadow-lg hover:shadow-2xl overflow-hidden transition-all duration-500 group hover:-translate-y-3"
              >

                {/* CLICKABLE IMAGE */}
                <Link to={service.link}>
                  <div className="relative overflow-hidden cursor-pointer">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-56 object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                </Link>

                <div className="p-8 text-center">

                  {/* CLICKABLE ICON */}
                  <Link to={service.link}>
                    <div className="icon-circle cursor-pointer mx-auto mb-4 border-2 border-[#421492] w-16 h-16 flex items-center justify-center rounded-full">
                      <i className={`fa ${service.icon} text-[#421492] text-2xl`}></i>
                    </div>
                  </Link>

                  {/* CLICKABLE TITLE */}
                  <Link to={service.link}>
                    <h4 className="text-xl font-bold text-[#210A4A] mb-3 hover:text-[#421492] transition">
                      {service.title}
                    </h4>
                  </Link>

                  <p className="text-gray-600 text-sm mb-6 min-h-[80px]">
                    {service.description}
                  </p>

                  {/* READ MORE BUTTON */}
                  <Link
                    to={service.link}
                    className="inline-flex items-center text-[#421492] font-bold text-sm hover:text-[#210A4A] transition"
                  >
                    READ MORE
                    <svg
                      className="w-5 h-5 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top Button */}
      {showScroll && (
        <div
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 cursor-pointer w-14 h-14 bg-blue-600 rounded-full flex items-center justify-center shadow-lg text-white"
        >
          ↑
        </div>
      )}
    </div>
  );
};

export default OurServices;
